// Core imports
import * as React from 'react';

// Components imports

// Models imports

// Style and misc imports
import './TrackingHeader.scss';

interface ITrackingHeaderProps {
  setOrderColumn(sortBy: string, sortIn: string): void;
  header: { label: string; sortBy: string };
  orderIn: 'ASC' | 'DESC' | 'AUTO';
  orderBy: string;
}

class TrackingHeader extends React.Component<ITrackingHeaderProps, any> {
  private handleSortColumn = (header: { label: string; sortBy: string }) => {
    return header.sortBy
      ? this.props.setOrderColumn(header.sortBy, this.props.orderIn)
      : null;
  };

  public render() {
    const { header } = this.props;

    let asc = '';
    let desc = '';

    if (this.props.orderIn === 'DESC') {
      asc = 'active';
      desc = '';
    } else if (this.props.orderIn === 'ASC') {
      asc = '';
      desc = 'active';
    }

    return (
      <div
        className={`rp-tracking-table--header ${
          header.sortBy ? 'clickable' : ''
        } rp-tracking-table--header-column`}
      >
        <p
          className={
            header.sortBy
              ? 'title-with-sort'
              : header.label?.toLowerCase() === 'shipped from' ||
                header.label?.toLowerCase() === 'confirmation number'
              ? 'title no-padding-tracking'
              : 'title'
          }
          onClick={() => {
            this.handleSortColumn(header);
          }}
        >
          {header.label}
        </p>
        {header.sortBy && (
          <div
            className="table-header-order"
            onClick={() => {
              this.props.setOrderColumn(header.sortBy, this.props.orderIn);
            }}
          >
            <i className={`rpds-arrow-drop-up ${desc}`} />
            <i className={`rpds-arrow-drop-down ${asc}`} />
          </div>
        )}
      </div>
    );
  }
}

export default TrackingHeader;
